var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { utilTime } from "../../../utils/utilTime";
import { TypeActionBaseInfo } from "./actionBaseInfo";
var initial = {
    buildings: [],
    expansionIds: [],
    farmId: -1,
    happiness: 0,
    maxWorkers: 0,
    name: "",
    playerId: Long.ZERO,
    usedWorkers: 0,
};
export var reducerBaseInfoReceived = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionBaseInfo.Received && action.baseInfo != undefined) {
        return __assign({}, state, action.baseInfo, { buildings: action.baseInfo.buildings.map(function (val) { return (__assign({}, val, { posX: val.posX || 0, posY: val.posY || 0, remainingTime: utilTime.remainingTimeToTimestamp(val.remainingTime) })); }) });
    }
    else if (action.type === TypeActionBaseInfo.AddBuilding && action.building != undefined) {
        return __assign({}, state, { buildings: state.buildings.concat([
                __assign({}, action.building, { posX: action.building.posX || 0, posY: action.building.posY || 0, remainingTime: utilTime.remainingTimeToTimestamp(action.building.remainingTime) }),
            ]) });
    }
    else if (action.type === TypeActionBaseInfo.RemoveBuilding && action.building != undefined) {
        return __assign({}, state, { buildings: state.buildings.filter(function (building) { return building.id !== action.building.id; }) });
    }
    else if (action.type === TypeActionBaseInfo.UpdateBuilding && action.building != undefined) {
        var building = __assign({}, state.buildings.find(function (b) { return b.id === action.building.id; }), action.building, { remainingTime: utilTime.remainingTimeToTimestamp(action.building.remainingTime) });
        return __assign({}, state, { buildings: state.buildings.filter(function (b) { return b.id !== action.building.id; }).concat([building]) });
    }
    else if (action.type === TypeActionBaseInfo.AddExpansion) {
        return __assign({}, state, { expansionIds: state.expansionIds.concat([action.expansionId]) });
    }
    else if (action.type === TypeActionBaseInfo.FinishConstruction) {
        return __assign({}, state, { buildings: state.buildings.map(function (b) {
                return b.id !== action.building.id
                    ? b
                    : __assign({}, b, { remainingTime: undefined });
            }) });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/base/reducerBaseInfo.ts
// module id = 2533
// module chunks = 3